import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=dc3ae5ba&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=dc3ae5ba&prod&scoped=true&lang=scss"
import style1 from "./NewsDetail.vue?vue&type=style&index=1&id=dc3ae5ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3ae5ba",
  null
  
)

export default component.exports